import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";

/**
 * Extrai a primeira mensagem de erro de um FetchBaseQueryError gerado pela baseApi.
 * O envelope ApiResponse<T> já é normalizado pela baseApi: `error.data` será `string[]`.
 *
 * @param error    O objeto `result.error` retornado pela mutation/query RTK Query.
 * @param fallback Mensagem exibida quando o backend não fornece detalhes (erro de rede, etc.).
 */
export function getApiErrorMessage(
  error: unknown,
  fallback = "Ocorreu um erro inesperado."
): string {
  const data = (error as FetchBaseQueryError)?.data;

  // Formato 1: data é string[] direto (extraído pelo unwrapEnvelope)
  if (Array.isArray(data)) {
    return (data as string[])[0] ?? fallback;
  }

  // Formato 2: data é o envelope completo { statusCode, errors, traceId, ... }
  const envelope = data as
    | { statusCode?: number; errors?: string[]; traceId?: string }
    | undefined;
  if (envelope?.errors && Array.isArray(envelope.errors) && envelope.errors.length > 0) {
    const mensagem = envelope.errors[0];
    // RB-007 (199952) — no 500 genérico ("Erro interno do servidor."), anexa o código de
    // correlação (traceId) para o usuário citar ao suporte e ligar o relato à linha de log.
    if (envelope.statusCode === 500 && envelope.traceId) {
      return `${mensagem} (código ${envelope.traceId})`;
    }
    return mensagem;
  }

  return fallback;
}
